import React, { useEffect, useState } from 'react';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, Grid, Typography } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../../Models/Utilisateur';
import SetMultipleDocument from '../../../../SetMultipleDocument';
import ReadOnlyDocumentList from '../../../../ReadOnlyDocumentList'; // à créer ou importer

let searchDocument: Params = {
  CodeAgence: 'Ijara',
  Table: "vw_DocumentsParEtape",
  Colonne1: "CodeEtape",
  Colonne2: "",
  Colagence: 'CodeProcessus',
  Init: 'VALIDATION',
  Choix: 34
};

function Tab5(props: { form?: any; document?: any[]; loading?: boolean }) {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  return (
    <div className='tabItem'>
      <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} p={2}>
        <Typography variant="subtitle1" color="primary" gutterBottom>
           Documents soumis précédemment
        </Typography>
        <ReadOnlyDocumentList documents={props.document || []} loading={props.loading || false} />

        <Box mt={3}>
          <Typography variant="subtitle1" color="primary" gutterBottom>
             Ajouter des documents pour la validation
          </Typography>
          <SetMultipleDocument
            form={props.form}
            Size="large"
            width={4}
            label="Documents"
            name="Document"
            Parametre={searchDocument}
          />
        </Box>
      </Box>
    </div>
  );
}

export default Tab5;